module.exports = __webpack_public_path__ + "img/sjcbg_img.bd725abf.png";